<script setup lang="ts">
import { CtBottomSheet } from '@camelot/components'
import type { UseSwipeDirection } from '@vueuse/core'
import { useSwipe } from '@vueuse/core'
import ExpandedBottomSheet from '~/components/sidebar/mobile/BottomSheetContent.vue'
import MobileSumm from '~/components/sidebar/mobile/MobileSumm.vue'

const sheetOpenState = ref(false)

// needs to be set in style and component to overwrite defaults
const bottomSheetBorders = {
  'border-top-left-radius': '0',
  'border-top-right-radius': '0',
}

const target = ref<HTMLElement>()

useSwipe(
  target,
  {
    onSwipeEnd(_: TouchEvent, direction: UseSwipeDirection) {
      if (direction === 'up')
        openSheet()
    },
  },
)

function openSheet() {
  sheetOpenState.value = true
}

function closeSheet() {
  sheetOpenState.value = false
}
</script>

<template>
  <div class="sticky bottom-0 w-full">
    <MobileSumm ref="target" class="drop-shadow-md shadow-negative z-50" @details-pressed="openSheet" />
    <CtBottomSheet
      class="z-10 rounded-none"
      :open="sheetOpenState"
      :backdrop-clickable="true"
      :backdrop-visible="true"
      data-testid="bottom-sheet"
      :style="bottomSheetBorders"
      @close="closeSheet"
    >
      <ExpandedBottomSheet @close-sheet="closeSheet" />
    </CtBottomSheet>
  </div>
</template>

<style scoped lang="scss">
/* stylelint-disable selector-class-pattern */
:deep(.a-bottom-sheet__content) {
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
